import { format } from "date-fns";

export const formatStartDate = (date) =>
  `${format(new Date(date), "yyyy-MM-dd")}T00:00:00.000Z`;

export const formatEndDate = (date) =>
  `${format(new Date(date), "yyyy-MM-dd")}T23:59:59.999Z`;
